module.exports = __webpack_public_path__ + "img/avatar1.e1a4cffe.png";